import gql from 'graphql-tag'

export const USER_LOGIN = gql`
  query userLogin($userName: String!, $password: String!) {
    security {
      authenticate(userName: $userName, password: $password) {
        authenticationResult {
          userId
          accessToken
          idToken
          refreshToken
        }
        challengeResult {
          challengeName
          session
          challengeParameters
        }
      }
    }
  }
`
export const GET_USER_PROFILE_BY_ID = gql`
  query getUserProfileById($userId: String!) {
    me(userId: $userId) {
      profile {
        id
        userName
        firstName
        lastName
        email
      }
    }
  }
`

export const GET_USER_ROLES = gql`
  query getUserRoles($userId: String!) {
    me(userId: $userId) {
      profile {
        id
        roles
      }
    }
  }
`

export const CHANGE_PASSWORD = gql`
  query changePassword($currentPassword: String!, $newPassword: String!) {
    security {
      changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
        success
      }
    }
  }
`

export const REFRESH_TOKEN = gql`
  query refreshToken($refreshToken: String!) {
    security {
      refreshAuthToken(refreshToken: $refreshToken) {
        authenticationResult {
          accessToken
        }
      }
    }
  }
`

export const SET_NEW_PASSWORD = gql`
  query setNewPassword($session: String!, $userName: String!, $newPassword: String!) {
    security {
      respondToNewPasswordRequiredChallenge(userName: $userName, newPassword: $newPassword, session: $session) {
        authenticationResult {
          userId
          accessToken
          idToken
          refreshToken
        }
      }
    }
  }
`

export const FORGOT_PASSWORD = gql`
  query sendEmailQuery($userName: String!) {
    security {
      forgotPassword(userName: $userName) {
        success
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  query resetPassword($confirmationCode: String!, $userName: String!, $newPassword: String!) {
    security {
      confirmForgotPassword(userName: $userName, newPassword: $newPassword, confirmationCode: $confirmationCode) {
        success
      }
    }
  }
`

export const GET_WIDGETS_LIST = gql`
  query listCoordinator {
    coordinator {
      dashboardWidget {
        list {
          widget
          allowed
        }
      }
    }
  }
`

export const GET_ACCOUNTS_LIST = gql`
  query getAccountsList {
    coordinator {
      account {
        list {
          id
          name
        }
      }
    }
  }
`
